// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c28efe42","977":"87b2e812"}[chunkId] + ".chunk.js";
};